import { DOM_ID } from './constants'

export const scrollAppPageToTop = () => {
  document.getElementById(DOM_ID.appRouteOutletWrapper)?.scrollTo({ top: 0 })
}
